'use client'
import { usePathname, useSearchParams, useRouter } from 'next/navigation'
import { getDynamicParams, getDynamicPath } from './appRouterHelpers'

// useRouter equivalents: useRouter left side and appRouter equivalents right side
// pathname = dynamicPathname
// query = query
// asPath = fullAsPath
interface AppRouter {
  dynamicPathname: string
  asPath: string
  query: Record<string, string | string[]>
  fullAsPath: string
  params: {
    categoryname?: string
    slug?: string
    page?: string
    pid?: string
  }
  push: ReturnType<typeof useRouter>['push']
  replace: ReturnType<typeof useRouter>['replace']
  hash: string | null
  searchParams: URLSearchParams
}

export function useAppRouter(): AppRouter {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const params = getDynamicParams(pathname ?? '/')
  const query: Record<string, string | string[]> = {}
  const hash = typeof window !== 'undefined' ? window.location.hash.slice(1) : null

  if (searchParams) {
    searchParams.forEach((value, key) => {
      if (query[key]) {
        query[key] = Array.isArray(query[key])
          ? [...(query[key] as string[]), value]
          : [query[key] as string, value]
      } else {
        query[key] = value
      }
    })
  }

  return {
    dynamicPathname: getDynamicPath(pathname ?? '/'),
    asPath: pathname ?? '/',
    query,
    fullAsPath: `${pathname ?? '/'}${
      searchParams?.toString() ?? '' ? '?' + (searchParams?.toString() ?? '') : ''
    }`,
    params,
    push: router.push,
    replace: router.replace,
    hash,
    searchParams: searchParams ?? new URLSearchParams(),
  }
}
